var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAaffOvLogoRgb1000PxSimbolo02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1128.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff5c35;\n      }\n\n      .cls-2 {\n        fill: #ff8d6b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.85,13.49l349.23,491.68c24.63,34.68,24.63,81.14,0,115.81l-349.23,491.68c-5.75,8.1-18.52,4.03-18.52-5.91V19.4c0-9.94,12.76-14.01,18.52-5.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.18,13.49l349.23,491.68c24.63,34.68,24.63,81.14,0,115.81L33.18,1112.66c-5.75,8.1-18.52,4.03-18.52-5.91V19.4c0-9.94,12.76-14.01,18.52-5.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaffOvLogoRgb1000PxSimbolo02);
export default __webpack_public_path__ + "static/media/aaff OV_logo_rgb_1000px SIMBOLO 02.05a8358a5d4ef3403a8a823da451dba0.svg";
export { ForwardRef as ReactComponent };